import { render, staticRenderFns } from "./edit-score-modal.vue?vue&type=template&id=0a24c04d"
import script from "./edit-score-modal.vue?vue&type=script&lang=js"
export * from "./edit-score-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports